<template>
  <div class="p-4 p-md-5 mb-4 container rounded text-body-emphasis bg-bd-blue d-flex flex-column flex-lg-row">
    <div class="col-lg-6 d-flex flex-column justify-content-evenly px-0">
      <h1 class="text-light open700">Install the app</h1>
      <p class="my-3 text-light open400">It's never been easier to order food. Look for the finest discounts and you'll be
        lost in a world of
        delectable food.</p>
      <div class="d-flex align-items-center justify-content-evenly flex-column flex-sm-row">
        <a href="https://play.google.com/store/apps/details?id=com.getit.badidukkan" target="_blank"><img
            src="@/assets/google-play-badge.png" alt="Google Play Badge" style="width: auto; height: 90px;" class="img-fluid"></a>
        <a href="" target="_blank"><img src="@/assets/AppStore_Badge.svg" alt="App Store Badge" class="img-fluid"></a>
      </div>
    </div>
    <img src="@/assets/rider-app.svg" alt="app" class="col-lg-6 img-fluid">
  </div>

  <div class="container py-5 my-5 text-center">
    <h1 class="open600">How Rider works</h1>
    <p class="open400">Download Rider app from playstore, create a account and get notified from a vendor.
      Delivery a food and earn money.</p>
    <img src="@/assets/rider_app_features.svg" alt="features" class="img-fluid">
  </div>

  <div class="p-4 p-md-5 mb-4 container rounded text-body-emphasis bg-bd-blue d-flex flex-column flex-lg-row">
    <img src="@/assets/rider_app_bt_1.svg" alt="app" class="col-lg-4 img-fluid">
    <div class="col-lg-4 d-flex flex-column justify-content-evenly px-0">
      <h1 class="text-light open700">Download the app</h1>
      <p class="my-3 text-light open400">Once you login, check in on the BadiDukkan Rider app whenever you are ready to
        drive.
        Deliver orders quickly and smoothly with automatic GPS directions. Get paid every week for your deliveries.</p>
      <div class="d-flex align-items-center justify-content-evenly flex-column flex-sm-row">
        <a href="https://play.google.com/store/apps/details?id=com.getit.badidukkan" target="_blank"><img
            src="@/assets/google-play-badge.png" alt="Google Play Badge" style="width: auto; height: 90px;" class="img-fluid"></a>
        <a href="" target="_blank"><img src="@/assets/AppStore_Badge.svg" alt="App Store Badge" class="img-fluid"></a>
      </div>
    </div>
    <img src="@/assets/rider_app_bt_2.svg" alt="app" class="col-lg-4 img-fluid">
  </div>
</template>
